import { DataPeriods } from '@utils/dataPeriods';

export enum SurveyStatsStatus {
  Pending = 'pending',
  Completed = 'completed',
}

export enum UserStatsPermissionView {
  Explicit = 'explicit',
  Permission = 'permission',
}

// Array-based filters for multi-selection dropdowns
export type SurveyStatsFiltersProps = {
  initiatives?: string[];
  years?: string[];
  months?: string[];
  periods?: DataPeriods[];
  surveyStatuses?: SurveyStatsStatus[];
};
